import React from "react";
import { Dropdown } from "react-bootstrap";
import classNames from "classnames";

export type IDropdownItemComp = {
  key: 0 | string;
  label: string | JSX.Element | React.ReactElement;
  isHeader?: boolean;
};

interface IDropdownComp {
  id: string;
  onItemSelected: (key: string) => void;
  toggleElem: string | JSX.Element | React.ReactElement;
  items: IDropdownItemComp[];
  className?: string;
  toggleClassName?: string;
}

const DropdownComp: React.FC<IDropdownComp> = (props: IDropdownComp) => {
  const { id, toggleElem, items, className, toggleClassName } = props,
    classes = classNames("standard", className),
    toggleClasses = classNames("form-control", toggleClassName);

  return (
    <Dropdown className={classes} onSelect={props.onItemSelected}>
      <Dropdown.Toggle id={id} as="button" className={toggleClasses}>
        {toggleElem}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {items.map((item) => {
          if (item.isHeader) {
            return <Dropdown.Header key={item.key}>{item.label}</Dropdown.Header>;
          } else {
            return (
              <Dropdown.Item key={item.key} eventKey={item.key}>
                <span>{item.label}</span>
              </Dropdown.Item>
            );
          }
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownComp;
